import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.wallets')
  .factory('WalletsBalancesAPI', WalletsBalancesAPI);

function WalletsBalancesAPI(): BringozApi {
  return {
    base: `/wallets/balances`,
    infiniteScroll: {
      address: `/wallets/balances`,
      cmd: 'GET'
    },
    actions: {
      getTotalBalance: {
        address: 'totals',
        cmd: 'GET',
        updateable: true
      }
    }
  }
}
